// covered-by: frontends/carrie/src/ask-v2/routes/__tests__/pageRoutes.test.ts
// eslint-disable-next-line import/named
import { createRoute, useSearch } from "@tanstack/react-router";

import { askV2AuthLayoutRoute } from "./authLayout";

import { AskV2Home } from "../home/AskV2Home";

export type AskV2HomeSearch = {
  /** A request's open item id: the home opens that request's panel (the Expert's notice links here). */
  request?: string;
};

export function parseAskV2HomeSearch(
  search: Record<string, unknown>,
): AskV2HomeSearch {
  const request =
    typeof search.request === "string" && search.request.trim()
      ? search.request.trim()
      : undefined;
  return request ? { request } : {};
}

/** The home for `/` and `/ask-puntt`, with the request panel a notice asked for. */
export function AskV2HomeRoutePage() {
  const { request } = useSearch({ strict: false }) as AskV2HomeSearch;
  return <AskV2Home requestId={request} />;
}

export const askV2IndexRoute = createRoute({
  getParentRoute: () => askV2AuthLayoutRoute,
  path: "/",
  validateSearch: parseAskV2HomeSearch,
  component: AskV2HomeRoutePage,
});
